import React from 'react'
import Logo from '../images/logo.jpeg'
import Hero1 from '../images/logoImage.jpeg'
import { SiSololearn } from 'react-icons/si'
import { FaTree } from 'react-icons/fa'
import { PiBrainBold } from 'react-icons/pi'
import { MdAutoFixHigh } from 'react-icons/md'
import { FaRegHeart } from 'react-icons/fa'
import InfoCard from './InfoCard'
import { IoIosArrowDropleft } from 'react-icons/io'
import { IoCall } from 'react-icons/io5'

export default function Hero() {
  return (
    <div id="hero">
      <div className="bg-hero relative overflow-hidden">
     

        <div className="p-4 pt-32 relative z-10">
          <div className="relative">
            <img
              alt="מלי דיין - יועצת זוגית ומשפחתית"
              className="w-48 rounded-full mt-4 hover-glow mx-auto border-4 border-white  transition-all duration-500 transform "
              src={Logo}
              data-aos="zoom-in"
            />
          </div>
          
          <h1 
            className="text-5xl md:text-6xl text-center font-extrabold gradient-text-animated mt-12"
            data-aos="fade-up" 
            data-aos-delay="200"
          >
            מלי דיין
          </h1>
          
          <h1 
            className="text-2xl md:text-3xl text-center font-extrabold text-black mt-2 hover:text-primary transition-colors duration-300"
            data-aos="fade-up" 
            data-aos-delay="300"
          >
            יועצת זוגית ומשפחתית
          </h1>
          
          <h3 
            dir="rtl"
            className="text-2xl text-black md:text-4xl text-center font-light mt-2 max-w-4xl mx-auto leading-relaxed"
            data-aos="fade-up" 
            data-aos-delay="400"
          >
            חיזוק הקשרים המשפחתיים, <br />בניית תקשורת בריאה <br />ויצירת בית חם ואוהב
          </h3>

          <div 
            className="flex flex-col-reverse sm:flex-row mt-8 justify-center gap-4"
            data-aos="fade-up" 
            data-aos-delay="500"
          >
            <a
              href="#aboutus"
              className="group bg-transparent m-2 px-10 py-4 text-lg border-2 border-black text-black font-extrabold rounded-full hover-lift transition-all duration-300 text-center relative overflow-hidden"
            >
              <span className="relative z-10">קצת עליי</span>
              <span className="absolute inset-0 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 font-extrabold">
                קצת עליי
              </span>
            </a>
            <a
              href="#messageLeadForm"
              className="group text-center bg-card hover:from-primary hover:to-card m-2 text-white px-10 py-4 text-lg font-extrabold rounded-full hover-lift transition-all duration-300 animate-shine relative overflow-hidden"
            >
              <span className="relative z-10">לשיחת ייעוץ</span>
              <div className="absolute inset-0 bg-white/20 translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
            </a>
          </div>
        </div>

        <div className="bg-gradient-to-t from-white to-transparent h-12"></div>
      </div>

      {/* Section with thought-provoking questions */}
      <div className="p-4 bg-gradient-to-br from-primary/5 to-card/10 relative">
        <div 
          className="p-6 max-w-[900px] mx-auto"
          data-aos="fade-up"
        >
          <h2 
            className="text-4xl md:text-5xl text-center gradient-text font-extrabold mb-8"
            data-aos="fade-down"
            dir="rtl"
          >
            שאלות שכולנו שואלים...
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" dir="rtl">
            <div 
              className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border-r-4 border-primary"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <p className="text-lg md:text-xl text-gray-800 font-medium leading-relaxed">
                "למה אנחנו רבים כל הזמן על אותם דברים?"
              </p>
            </div>
            
            <div 
              className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border-r-4 border-card"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <p className="text-lg md:text-xl text-gray-800 font-medium leading-relaxed">
                "איך זה שאנחנו כל כך זרים אחד לשני?"
              </p>
            </div>
            
            <div 
              className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border-r-4 border-primary"
              data-aos="fade-right"
              data-aos-delay="300"
            >
              <p className="text-lg md:text-xl text-gray-800 font-medium leading-relaxed">
                "מתי האהבה הפכה להיות כל כך קשה?"
              </p>
            </div>
            
            <div 
              className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border-r-4 border-card"
              data-aos="fade-left"
              data-aos-delay="400"
            >
              <p className="text-lg md:text-xl text-gray-800 font-medium leading-relaxed">
                "איפה נעלם הקשר שהיה לנו בהתחלה?"
              </p>
            </div>
            
            <div 
              className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border-r-4 border-primary"
              data-aos="fade-right"
              data-aos-delay="500"
            >
              <p className="text-lg md:text-xl text-gray-800 font-medium leading-relaxed">
                "למה כל שיחה הופכת לוויכוח?"
              </p>
            </div>
            
            <div 
              className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border-r-4 border-card"
              data-aos="fade-left"
              data-aos-delay="600"
            >
              <p className="text-lg md:text-xl text-gray-800 font-medium leading-relaxed">
                "איך נחזיר את האושר לבית שלנו?"
              </p>
            </div>
          </div>
          
          <div 
            className="text-center mt-8"
            data-aos="fade-up"
            data-aos-delay="700"
          >
            <p className="text-xl md:text-2xl text-gray-700 font-medium italic">
              אם שאלתם את עצמכם אחת מהשאלות האלה - אתם לא לבד
            </p>
            <div className="w-32 h-1 bg-gradient-to-r from-primary to-card mx-auto mt-4 rounded-full"></div>
          </div>
        </div>
      </div>

      <div className="p-4 dotbg relative">
        <div 
          className="p-6 max-w-[1000px] mx-auto overflow-hidden relative" 
          data-aos="fade-up"
        >
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="card-inner" dir="rtl">
            <h1 
              dir="rtl" 
              className="text-5xl md:text-6xl text-center gradient-text font-extrabold mt-2"
            >
              למה זוגיות?
            </h1>

            <div className="space-y-6 mt-8">
              <p 
                className="md:text-2xl max-w-[1000px] mx-auto text-center px-4 leading-relaxed"
              >
                זוגיות ואהבה תמיד מחוברים וקשורים זו לזו ובכל זאת, כל זוג עובר משברים שיכולים לחזק או להחליש אותו.
              </p>

              <p 
                className="md:text-2xl max-w-[1000px] mx-auto text-center px-4 font-bold text-primary"
              >
                למה זה קורה לנו?
              </p>

              <p 
                className="md:text-2xl max-w-[1000px] mx-auto text-center px-4 leading-relaxed"
              >
                כי אנחנו אנשים שונים שמגיעים מבתי גידול שונים - ערכים, אמונות ומודל זוגי שונה שראינו בבית ומצפים שכל זה
                יתחבר לזוגיות טובה ואוהבת ללא קשיים או אתגרים.
              </p>

              <p 
                className="md:text-2xl max-w-[1000px] mx-auto text-center px-4 leading-relaxed"
              >
                רק שלאורך הזמן צצים ועולים הפערים ואנחנו מגלים שזוגיות טובה ואוהבת מצריכה מאיתנו מאמץ, עבודה והשקעה אישית.
              </p>

              <p 
                className="md:text-2xl max-w-[1000px] mx-auto text-center px-4 leading-relaxed"
              >
                המודל הזוגי שלנו מגיע מההורים, מסרטי דיסני ורומנים שקראנו ואף אחד לא באמת לימד אותנו מהי זוגיות טובה עד
                שנכנסנו אליה והתחלנו ללמוד, להתפתח ולגדול תוך כדי לחוד וביחד.
              </p>

              <div 
                className="bg-gradient-to-r from-primary/10 to-card/10 rounded-2xl p-6 backdrop-blur-sm border border-primary/20"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <p className="md:text-2xl max-w-[1000px] mx-auto text-center px-4 font-bold gradient-text-animated italic">
                  "אין כמו אהבה ואין כמו בית, ואין כמו אהבה שנותנת בית, ואין כמו בית שנותן אהבה."
                </p>
                <p className="md:text-xl text-primary text-sm max-w-[1000px] mx-auto text-center px-4 mt-4 font-extrabold">
                  עידית ברק
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div 
        id="messageLeadForm" 
        className="flex justify-center my-12 text-white"
      >
        <a
          href="tel:+972509933553"
          className="group bg-card  hover:to-card text-center flex justify-center items-center m-2 px-10 py-4 text-lg font-extrabold rounded-full hover-lift transition-all duration-300   relative overflow-hidden"
        >
          <IoCall className="text-4xl mr-4 group-hover:animate-wiggle" />
          <span className="text-xl md:text-2xl relative z-10">חייגו אליי לשיחת ייעוץ</span>
          <div className="absolute inset-0 bg-white/10 translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
        </a>
      </div>

      <div className="bg-gradient-to-tr bg-brown p-4 py-12 relative overflow-hidden" id="couples-counseling">
        {/* Background floating elements */}
        <div className="absolute inset-0 pointer-events-none opacity-20">
          <div className="absolute top-16 right-10 w-24 h-24 bg-primary/30 rounded-full animate-float"></div>
          <div className="absolute bottom-20 left-16 w-32 h-32 bg-card/20 rounded-full animate-float" style={{animationDelay: '3s'}}></div>
        </div>

        <h1 
          dir="rtl" 
          className="text-5xl md:text-6xl text-center gradient-text-animated font-extrabold mt-12 relative z-10"
          data-aos="fade-down"
        >
          למה יועצת זוגית?
        </h1>

        <div 
          className="flex justify-center items-center mt-8 p-4 mx-8 relative z-10"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 rounded-2xl gap-8 max-w-[1200px]">
            <div data-aos="zoom-in" data-aos-delay="100">
              <InfoCard icon={SiSololearn} title="כדי ללמוד" description="כלים איך לשפר את הזוגיות" />
            </div>
            <div data-aos="zoom-in" data-aos-delay="200">
              <InfoCard
                icon={FaTree}
                title="כדי להצמיח"
                description="את הזוגיות שלנו וליצור חיבורים ותחושות טובות יותר"
              />
            </div>
            <div data-aos="zoom-in" data-aos-delay="300">
              <InfoCard icon={PiBrainBold} title="כדי להבין" description="איך לצמוח באופן אישי בתוך הזוגיות" />
            </div>
            <div data-aos="zoom-in" data-aos-delay="400">
              <InfoCard icon={MdAutoFixHigh} title="כדי לשפר" description="את החיים שלנו ולחיות טוב יותר" />
            </div>
            <div data-aos="zoom-in" data-aos-delay="500">
              <InfoCard icon={FaRegHeart} title="כדי להפנים" description="שאתם לא לבד" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
